import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { clsx } from 'clsx';
import { useTheme } from '../ThemeProvider';

interface ISpinLoading {
    rootClassName?: string;
    size?: number;
}

export function SpinLoading({ rootClassName, size }: ISpinLoading) {
    const { theme } = useTheme();
    return (
        <div
            className={clsx(
                `absolute z-[9999] top-0 left-0 right-0 bottom-0 w-full h-full bg-white opacity-75 rounded-xl 
  flex justify-center items-center pointer-events-none cursor-not-allowed`,
                rootClassName
            )}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <Spin
                indicator={
                    <LoadingOutlined rev={'test'} spin size={size ?? 32} />
                }
                style={{ color: theme.colors.primary.main.filled }}
            />
        </div>
    );
}
